function initEquipmentSlider() {
  const sliders = document.querySelectorAll('[data-slider]');

  sliders.forEach((slider) => {
    const styles = getComputedStyle(slider);
    const progressBar = slider.parentElement.querySelector('[data-progress-bar]');

    function updateProgress() {
      if (!progressBar) return;
      const scrollLeft = slider.scrollLeft;
      const scrollWidth = slider.scrollWidth - slider.clientWidth;

      const progressBarWidth = 76;
      const progressTrackWidth = progressBar.parentElement.offsetWidth;
      const availableSpace = progressTrackWidth - progressBarWidth;

      const scrollPercentage = scrollWidth > 0 ? scrollLeft / scrollWidth : 0;
      const position = scrollPercentage * availableSpace;

      progressBar.style.left = position + 'px';
    }

    updateProgress();
    slider.addEventListener('scroll', updateProgress);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEquipmentSlider);
} else {
  initEquipmentSlider();
}
